export class EnrollmentElectionType {
    ElectionTypeReasonCode: number
    ElectionTypeShortName: string
    ElectionTypeName: string
    LongDescription: string
    IsDateField: boolean
    ElectionTypeReasonSubCode: string
    ElectionTypeID: number
}
